import { jsx } from "react/jsx-runtime";
import { useEvent } from "@tamagui/core";
import { useMemo } from "react";
import { SheetControllerContext } from "./useSheetController";
const SheetController = ({
  children,
  onOpenChange: onOpenChangeProp,
  ...value
}) => {
  const onOpenChange = useEvent(onOpenChangeProp);
  const memoValue = useMemo(
    () => ({
      open: value.open,
      hidden: value.hidden,
      disableDrag: value.disableDrag,
      onOpenChange
    }),
    [onOpenChange, value.open, value.hidden, value.disableDrag]
  );
  return /* @__PURE__ */ jsx(SheetControllerContext.Provider, { value: memoValue, children });
};
export {
  SheetController
};
//# sourceMappingURL=SheetController.js.map
